import { AbstractInterface } from './AbstractInterface';

/*
 * This service handles connection lost.
 */
export class InterruptionInterface extends AbstractInterface {

  // "Connection re established!"
  public static onOnlineFixme(): void {
    this.mediator.hideLastMessage();
  }

  // "Connection lost!"
  public static onOfflineInterruption(): void {
    this.mediator.showConnectionLostMessage();
  }
}
